module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "campzy-frame-chrome-mac.3e9fae09.webp";